module.exports = __webpack_public_path__ + "img/foot_line.png";